enum SidebarView {
  Loads = 'Loads',
  Quote = 'Quote',
}

export default SidebarView;
